import React, { useContext, useEffect } from "react"
import { AuthCheck } from "./AuthCheck"
import { AuthContext, AuthStatus } from "components/authentication/context/authContext"
import SecurityWrapperRoutes from "components/authorization/SecurityWrapperRoutes"
import { Navigate, Route, Routes } from "react-router"
import ErrorTemplateFoundPage from "../ErrorTemplatePage"
import intl from 'components/i18n/ReactIntlWrapper';
import Spinner from "components/Spinner"
import { PageLogin } from "components/PageLogin"

export default function BerpRoutes() {
    const { authStatus } = useContext(AuthContext);
    return (<>
        <AuthCheck status={AuthStatus.SignedIn}>
            <SecurityWrapperRoutes />
        </AuthCheck>
        <AuthCheck status={AuthStatus.SignedOut}>
            <Routes>
                <Route path="/login" element={<PageLogin />} />
                <Route path="/verify" element={<Spinner />} />
                <Route path="*" element={authStatus === AuthStatus.SignedOut ? <Navigate to="/login" /> : <ErrorTemplateFoundPage statusCode={404} title={intl.get('notFoundPage.title')} />} />
            </Routes>
        </AuthCheck>
        </>
    )
}
